// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../assets/scripts/index.js");
var __webpack_exports__ = __webpack_require__("../assets/scripts/sks/pageh.js");
